<template>
    <div :class="(checkall)?'input-group fullwidth selector':'selector'">
      <div v-if="loading" class="loadicon">
        <img src="/icons/loading.gif"/>
      </div>
      <treeselect
          v-if="tree"
          @select="treeselect"
          v-model="v1"
          :options="items"
          :searchNested="true"
          :placeholder="(empty==null)?'Поиск':empty" :appendToBody="tobody">
        <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="[labelClassName,node.raw.class]" :title="node.raw.title">
          {{ node.label }}
          <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
        </label>
      </treeselect>
    <select2 v-model="v1" @input="selectItem" v-bind="$attrs" :options="items2" v-if="select2" :multiple="multiple" :settings="(select2!==true)?{theme:'bootstrap',width:'100%',...select2}:{theme:'bootstrap',width:'100%'}" @select="select2Item" @change="select2Change"></select2>
    <select class="form-control" v-model="v1" @input="selectItem" v-bind="$attrs" v-if="!select2&&!tree">
        <template v-if="this.optgroups.length>0">
            <optgroup v-for="optgroup in this.optgroups" :key="optgroup" :label="optgroup">
                <option v-for="item in optgroupitems(optgroup)" :key="item.__key" v-bind:value="item.id" :selected="(item.id==v1)">{{ item[valueField] }}</option>
            </optgroup>
        </template>
        <template v-else>
            <option v-for="item in items" :key="item.__key" v-bind:value="item.id" :selected="(item.id==v1)">{{ item[valueField] }}</option>
        </template>
    </select>
    <span v-if="checkall" class="input-group-btn">
        <button class="btn btn-info btn-sm" title="Выбрать все" @click="selectAll"><span class="glyphicon glyphicon-check"></span></button>
    </span>
    </div>
</template>

<script>
    import axios from 'axios'
    import Treeselect from '@riophae/vue-treeselect'

    export default {
        props: ['options','params','query','remember','empty','select2','tree','value','checkall','prependdata','multiple'],
        emits: ['input','select','item-change'],
        data:function(){
            return {
                items:[],
                itemSelected:null,
                itemArray:[],
                v1:null,
                arrdata:[],
                optgroups:[],
                code:null,
                loading:null,
                tobody:(this.options?.tobody==false)?false:true
            }
        },
        computed:{
            valueField:function(){
                var vf="name";
                if ((this.options!=null)&&(this.options.field!=null)) vf=this.options.field;
                return vf;
            },
            items2:function(){
                if (this.optgroups.length>0)
                    return this.optgroups.map(o=>{
                        return { 'text':o,children:this.items.filter(d => (d.optgroup==o)).map(d=>{ return { 'id':d.id,'text':d[this.valueField],'disabled':d.disabled }; }) };
                    });
                else
                    return this.items.map(d=>{ return { 'id':d.id,'text':d[this.valueField],'disabled':d.disabled }; });
            },
        },
        methods:{
            selectItem:function(ev){
                if (ev.target==null) {
                  console.log(ev);
                  return;
                }
                this.itemSelected=this.itemArray[ev.target.value];
                this.$emit('input',ev.target.value);
                this.$emit('item-change',this.itemSelected);
                if (this.remember)
                {
                    var parts = new URLSearchParams(window.location.search);
                    var action = parts.get("action"); 
                    localStorage.setItem(action+"_selector_"+this.query,ev.target.value);
                }
                this.v1=ev.target.value;
            },
            select2Item:function({id,text}){
              if (this.select2.multiple) return;
                this.itemSelected=this.itemArray[id];
                this.$emit('input',id);
                this.$emit('item-change',this.itemSelected);
                if (this.remember)
                {
                    var parts = new URLSearchParams(window.location.search);
                    var action = parts.get("action"); 
                    localStorage.setItem(action+"_selector_"+this.query,id);
                }
                this.v1=id;
            },
            select2Change:function(ev)
            {
              if (!this.select2.multiple) return;
              this.$emit('input',this.v1);
            },
            treeselect(node){
              this.itemSelected=node;
              this.$emit('input',node.id);
              this.$emit('item-change',node);
              if (this.remember)
              {
                var parts = new URLSearchParams(window.location.search);
                var action = parts.get("action");
                localStorage.setItem(action+"_selector_"+this.query,node.id);
              }
              this.v1=node.id;
            },
            selectAll:function(ev)
            {
                if (this.v1.length<this.items.length)
                    this.v1=this.items.map(d=>d.id);
                else
                    this.v1=[];
                this.$emit('input',this.v1);
            },
            fetchData:async function(){
                var vars=new FormData();
                var query=this.query;
                var nullparams=false;
                if (this.options!=null)
                {
                    query=this.options.query??this.query;
                    nullparams=this.options.nullparams;
                    if (this.preoptions!=null)
                    {
                      this.processData(this.preoptions);
                    }
                }
                this.code=([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,c=>(c^crypto.getRandomValues(new Uint8Array(1))[0]&15 >> c/4).toString(16));
                this.loading=true;
                vars.set('actiondata',query);
                vars.set('queryid',this.code);
                for(var prop in this.params)
                {
                    vars.set(prop,this.params[prop]);
                    if ((!nullparams)&&(this.params[prop]===null)) { 
                        this.items=[];
                        return;
                    }
                }
                await axios.post("headless.php?actiondata="+query,vars).then((jd)=>{
                    if ((this.code!=null)&&(jd.headers.etag!=null)&&(jd.headers.etag!=this.code)) return;
                    this.loading=false;
                    this.processData(jd.data);
                });
            },
            refresh:async function(){
                this.fetchData();
            },
            addItem(d){
                d.__key=d.id;
                this.itemArray[d.id]=d;
                if (d.children!=null) {
                  d.children.map(this.addItem, d.children);
                }
            },
            processData:function(arr){
                var v=null;
                var vold=this.value;
                this.itemArray=[];
                this.optgroups=[];
                if (this.empty!=null) v="";
                if (arr==null) { this.items=[];return;}
                if (this.prependdata)
                    arr.unshift(this.prependdata);
//                console.log(arr);
                if (Array.isArray(arr))
                arr.map((d)=>{
                    this.addItem(d);
                    if (v===null) v=d.id;
                    if (d.optgroup!=null) { 
                        if (this.optgroups.indexOf(d.optgroup)===-1)
                            this.optgroups.push(d.optgroup);
                    }
                    return d; 
                });
                if ((this.itemArray[vold])||((this.select2!=null)&&(this.select2.multiple))) v=vold;
                if ((arr[0]==null)||(arr[0].id!=''))
                {
                    if (this.empty==1) arr.unshift({ id:'',name:'-Все-',__key:'0'});
                    else
                        if (this.empty!=null) arr.unshift({ id:'',name:this.empty});
                }
                if (this.remember)
                {
                    var parts = new URLSearchParams(window.location.search);
                    var action = parts.get("action"); 
                    var v1=localStorage.getItem(action+"_selector_"+this.query);
                    if (v1!=null) v=v1;
                }
                if (v!=null)
                {
                    this.itemSelected=this.itemArray[v];
                    this.$emit('input',v);
                    this.v1=v;
                    this.$emit('item-change',this.itemSelected);
                }   
                this.items=arr;
                this.$emit('load');
            },
            sorter:function(data){
                return data.sort((a, b) => a.text.localeCompare(b.text));
            },
            optgroupitems:function(optgroup)
            {
                return this.items.filter( a => (a.optgroup==optgroup));
            }
        },
        mounted:function(){
            if ((this.query==null)&&((this.options==null)||(this.options.query==null)))
                this.processData(this.params);
            else
                this.fetchData();
        },
        watch:{
            params: function(v1,v2){ 
                if (JSON.stringify(v1)!=JSON.stringify(v2))
                {
                    if ((this.query==null)&&((this.options==null)||(this.options.query==null)))
                        this.processData(this.params);
                    else
                        this.fetchData();
                }
            },
            value: function(v)
            {
                this.v1=v;
            }
        }
    }


</script>

<style>

    div.selector .select2-selection--multiple { max-height: 6rem; overflow-y: auto; }
    div.loadicon{
      display: block;
      position: absolute;
      top:3px;
      right:50%;
      z-index:10001;
    }
    div.loadicon img{
      width:15px;
      height:15px;
    }


</style>